<template>
  <div class="reviews">
    <h2 class="landing-page__title reviews__title">
      <div>{{ $t('reviews.feedback.firstText') }}</div>
      <span>{{ $t('reviews.feedback.secondText') }}</span>
      <div class="reviews__logo">
        <transition
          name="fade-el"
          mode="out-in"
          appear
        >
          <v-lazy-image
            :src="require('@/assets/images/logo-second.svg')"
            :srcPlaceholder="require('@/assets/images/landing/phImage.svg')"
            alt="logo"
          />
        </transition>
      </div>
    </h2>
    <div class="reviews__content">
      <div class="reviews__bg">
        <transition
          v-if="!mobileStatus"
          name="fade-el"
          mode="out-in"
          appear
        >
          <v-lazy-image
            :src="require('@/assets/images/landing/slider-bg.png')"
            :srcPlaceholder="require('@/assets/images/landing/phImage.svg')"
            alt="slider"
          />
        </transition>
        <transition
          v-else
          name="fade-el"
          mode="out-in"
          appear
        >
          <v-lazy-image
            :src="require('@/assets/images/landing/video-mobile.png')"
            :srcPlaceholder="require('@/assets/images/landing/phImage.svg')"
            alt="slider"
          />
        </transition>
      </div>
      <swiper
        ref="swiperSlide"
        :options="sliderOption"
      >
        <swiperSlide
          v-for="(elem, index) in reviewsList"
          :key="elem.id"
        >
          <div
            :key="elem.id"
            class="reviews-item"
            @click="openVideoSlider(index)"
          >
            <div class="reviews-item__image"></div>
            <div class="reviews-item__text">
              {{ $t(elem.text) }}
            </div>
            <div class="reviews-item__label">
              {{ $t(elem.label) }}
            </div>
            <div class="reviews-item-info">
              <!--              <div class="reviews-item-info-item">-->
              <!--                <div class="reviews-item-info-item__icon">-->
              <!--                  <i-->
              <!--                    class="ub-icon-company"-->
              <!--                  >-->
              <!--                  </i>-->
              <!--                </div>-->
              <!--                <span class="reviews-item-info-item__title">-->
              <!--                  {{ elem.company }}-->
              <!--                </span>-->
              <!--              </div>-->
              <div class="reviews-item-info-item">
                <div class="reviews-item-info-item__icon">
                  <i
                    class="ub-icon-country-1"
                  >
                  </i>
                </div>
                <span class="reviews-item-info-item__title">
                  {{ $t(elem.country) }}
                </span>
              </div>
              <!--              <div class="reviews-item-info-item">-->
              <!--                <div class="reviews-item-info-item__icon">-->
              <!--                  <i-->
              <!--                    class="ub-icon-reg"-->
              <!--                  >-->
              <!--                  </i>-->
              <!--                </div>-->
              <!--                <span class="reviews-item-info-item__title">-->
              <!--                  {{ elem.reg }}-->
              <!--                </span>-->
              <!--              </div>-->
            </div>
          </div>
        </swiperSlide>
        <div
          slot="button-prev"
          class="swiper-button-prev"
        >
          <i class="ub-icon-arrow"></i>
        </div>
        <div
          slot="button-next"
          class="swiper-button-next"
        >
          <i class="ub-icon-arrow"></i>
        </div>
        <div
          slot="pagination"
          class="swiper-pagination"
        >
        </div>
      </swiper>
    </div>
    <!-- На потом   -->
    <!--    <transition-->
    <!--      name="fade-el"-->
    <!--    >-->
    <!--      <videoSlider-->
    <!--        v-if="openModalVideoSlider"-->
    <!--        :openModalVideoSliderProps.sync="openModalVideoSlider"-->
    <!--      />-->
    <!--    </transition>-->
  </div>
</template>

<script>
import reviewsList from '@/constants/landing/reviews';
// import videoSlider from '@/components/landing/modals/videoSlider';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
import MobileDetect from 'mobile-detect';

export default {
  name: 'Reviews',
  components: {
    // videoSlider,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      openModalVideoSlider: false,
      reviewsList,
      currentSlide: 0,
      sliderOption: {
        effect: 'fade',
        centeredSlides: true,
        direction: 'horizontal',
        keyboardControl: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    };
  },
  computed: {
    mobileStatus() {
      const md = new MobileDetect(window.navigator.userAgent);
      const mobile = md.mobile();
      const tablet = md.tablet();
      return mobile !== null || tablet !== null;
    },
  },
  methods: {
    openVideoSlider(index) {
      if (this.currentSlide === index) {
        this.openModalVideoSlider = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../sass/variables";
@import "../../sass/mixins";

.reviews {
  overflow: hidden;
  padding-bottom: 70px;
  background: url("../../assets/images/landing/review-bg.jpg") no-repeat;
  background-size: cover;
  padding-top: 103px;
  margin-top: -15px;

  &__icon {
    position: absolute;
    top: 38%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 9999999;
    max-width: 153px;
    cursor: pointer;
  }

  &__content {
    position: relative;
    min-height: 500px;
    z-index: 5;
  }

  &__bg {
    position: absolute;
    left: 49%;
    transform: translateX(-50%);
    top: 0;
    max-width: 1300px;
    width: 100%;
    user-select: none;

    img {
      max-height: 500px;
      margin: auto;
      display: block;
    }
  }

  &__logo {
    display: inline-block;
    position: relative;
    left: 9px;
    top: 1px;

    img  {
      width: 355px;
      max-height: 48px;
    }
  }

  &__title {
    text-align: center;
    margin-bottom: 48px;

    div {
      letter-spacing: 1px;
      margin-bottom: 3px;
    }

    span {
      display: inline-block;
      font-family: $font-landing-heavy;
      margin-right: 20px;
    }
  }

  &-item {
    display: flex !important;
    flex-direction: column;
    cursor: pointer;

    &-info {
      max-width: 660px;
      padding-top: 6px;
      bottom: -217px;
      width: 100%;
      height: 62px;
      border-radius: 31px;
      background-color: $color-dodger-blue-dark;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      display: flex;
      align-items: center;
      justify-content: center;

      &:before {
        content: '';
        position: absolute;
        top: -12px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 16px solid transparent;
        border-right: 16px solid transparent;
        border-bottom: 12px solid $color-dodger-blue-dark;
      }

      &-item {
        margin: 0 25px;
        display: flex;
        align-items: center;

        &__icon {
          color: $color-white;
          font-size: 26px;
          margin-right: 4px;
        }

        &__title {
          font: $font-size-icon-sm $font-landing-global;
          color: $color-white;
        }
      }
    }

    &__text {
      font-size: $font-size-dd;
      font-family: $font-landing-medium;
      max-width: 500px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      position: absolute;
    }

    &__label {
      font-size: $font-size-xlg;
      font-family: $font-landing-medium;
      max-width: 500px;
      left: 50%;
      bottom: 20px;
      transform: translateX(-50%);
      position: absolute;
    }

    &__image {
      position: relative;
      max-height: 445px;
      max-width: 592px;
      height: 100%;
      width: 100%;
      min-height: 445px;
      min-width: 592px;
      line-height: 0;
      margin: auto;
      left: -3px;

      &:after {
        position: absolute;
        content: '';
        border-radius: 10px;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: $color-white;
      }

      img {
        border-radius: 10px;
      }
    }

    &__title {
      font: $font-size-huge $font-landing-semibold;
      color: $color-black;
      text-align: center;
    }

    &__subtitle {
      font: $font-size-landing-md $font-landing-medium;
      color: $color-silver-chalice;
      text-align: center;
    }
  }
}

@include desktop-small {
  .reviews {
    padding-bottom: 30px;

    .swiper-pagination {
      bottom: 200px;
    }

    &__bg {
      max-width: 1100px;
    }

    &-item {

      &-info {
        bottom: -100px;
        height: 52px;
      }

      &__label {
        bottom: 70px;
      }

      &__text {
        top: 40%;
        max-width: 450px;
        padding: 15px;
        font-size: $font-size-icon-xd;
      }

      &__image {
        min-height: auto;
        max-height: none;
        max-width: none;
        min-width: auto;
        width: 500px;
        height: 370px;
        left: 0;
      }
    }

    &__icon {
      top: 30%;
      max-width: 120px;
    }
  }
}

@include tablet-middle {
  .reviews {

    &__bg {
      width: 950px;
      max-width: 100%;
    }

    &-item {
      &__text {
        top: 35%;
      }

      &__label {
        bottom: 120px;
      }
    }

    .swiper-container {
      max-height: 600px;
      min-height: 600px;
    }

    .swiper-pagination {
      bottom: 160px;
    }

    &-item {

      &-info {
        bottom: -80px;
      }

      &__image {
        max-width: 430px;
        left: 4px;
        height: 320px;
      }
    }

    &__icon {
      max-width: 100px;
    }
  }
}

@include tablet-portrait {
  .reviews {
    padding-bottom: 0;

    &-item {
      &__text {
        font-size: $font-size-base;
        top: 25%;
        max-width: 300px;
      }

      &__label {
        bottom: 192px;
        font-size: $font-size-small;
      }
    }

    &__title {
      font-size: $font-size-landing-heading-tablet;
      display: flex;
      flex-direction: column;
      align-items: center;

      span {
        margin-right: 0;
        margin-bottom: 10px;
      }
    }

    &__logo {
      left: 0;
    }

    &__bg {
      max-width: 700px;
    }

    .swiper-container {
      max-width: 700px;
    }

    .swiper-pagination {
      bottom: 150px;
    }

    &__icon {
      max-width: 70px;
      top: calc(50% - 120px);
    }

    &-item {

      &-info {
        height: 40px;
        max-width: 550px;
        position: relative;
        top: 50px;

        &-item {
          margin: 0 20px;

          &__title {
            font-size: $font-size-lg;
          }

          &__icon {
            font-size: $font-size-dd;
          }
        }
      }

      &__image {
        max-width: calc(50% - 35px);
        position: relative;
        left: 0;
        top: -7px;
        height: 240px;
      }

      &__title {
        font-size: $font-size-landing-medium
      }

      &__subtitle {
        font-size: $font-size-landing-sm;
      }
    }

    .swiper {
      &-container {
        max-height: none;
        min-height: auto;
      }

      &-button-next, &-button-prev {
        max-width: 35px;
        min-width: 35px;
        height: 35px;
      }
    }
  }
}

@include mobile {
  .reviews {
    padding-top: 50px;
    padding-bottom: 10px;

    &-item {
      &__text {
        font-size: $font-size-landing-small;
        top: 20%;
        max-width: 320px;
        width: 100%;
      }

      &__label {
        bottom: 212px;
      }
    }

    &__icon {
      top: calc(50% - 100px);
    }

    &__bg {
      img {
        max-width: 320px;
        display: flex;
        justify-content: center;
        margin: auto;
        width: 100%;
      }
    }

    &__content {
      min-height: auto;
    }

    .swiper-slide-active {
      width: 100% !important;
    }

    &-item {
      width: auto !important;

      &-info {
        top: 70px;
      }

      &__image {
        left: 0;
        top: -10px;
        max-width: 300px;
        height: 225px;
      }
    }

    &__title {
      display: flex;
      flex-direction: column;

      span {
        margin-right: 0;
        margin-bottom: 10px;
      }
    }

    &__logo {
      left: 0;

      img {
        width: 200px;
      }
    }

    &__bg {
      left: 50%;
      max-width: 100%;
      width: 100%;
    }

    .swiper {
      &-button {

        &-next, &-prev {
          top: auto;
          max-width: 40px;
          min-width: 40px;
          height: 40px;
        }

        &-next {
          right: 15px;
          bottom: -70px;
        }

        &-prev {
          left: 15px;
          bottom: -50px;
        }
      }
    }

    &__title {
      font-size: $font-size-h1;
      margin-bottom: 40px;
    }

    .swiper {
      &-container {
        left: 0;
      }

      &-slide {
        &-active {
          width: 100% !important;
        }
      }
    }

    &-item {
      width: 320px;
      margin: auto;

      &__image {
        img {
          max-height: 319px;
        }
      }

      &__title {
        text-align: left;
        font-size: $font-size-base;
        margin-bottom: 3px;
      }

      &__subtitle {
        text-align: left;
      }
    }
  }
}

@include mobile-middle {
  .reviews {

    &-item-info {
      flex-direction: column;
      height: auto;
      max-width: 300px;
      min-width: 300px;
      padding: 10px;
      align-items: center;

      &-item {
        margin: 5px;
      }
    }
  }
}

</style>

<style lang="scss">
@import "../../sass/variables";
@import '../../../node_modules/swiper/swiper';

.reviews {
  .swiper{

    &-container {
      min-height: 656px;
      max-height: 656px;
      padding-bottom: 20px;
      max-width: 1260px;
      width: 100%;
    }

    &-pagination {
      position: absolute;
      bottom: 124px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 999;
      display: flex;

      &-bullet {
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: $color-gray;
        margin: 0 5px;
        cursor: pointer;
        transition: background-color .15s ease-in;
      }

      &-bullet-active {
        background: $color-black;
        width: 12px;
        height: 12px;
        background: $color-dodger-blue-light;
        position: relative;
        top: -2px;
      }
    }

    &-button-prev, &-button-next {
      position: absolute;
      max-width: 56px;
      min-width: 56px;
      height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background-color: $color-dodger-blue;
      font-size: 0;
      cursor: pointer;
      top: 40%;
      transform: translateY(-50%);
      border: 1px solid transparent;
      transition: all .15s ease-in;
      z-index: 1000;
      background-image: url('../../assets/images/landing/arrow-review.png');
      background-repeat: no-repeat;
      background-size: 25%;
      background-position: 50% 50%;

      &:hover {
        opacity: .7;
      }

    }

    &-button-prev {
      left: 15px;
      transform: rotate(-180deg);
      top: 36%;

      &:before {
        transform: rotate(180deg);
        position: relative;
        left: -1px;
      }
    }

    &-button-next {
      right: 15px;

      &:before {
        position: relative;
        left: 1px;
      }
    }

    &-button-disabled {
      background-color: $color-santas-gray !important;
      border-color: $color-santas-gray !important;
      cursor: default !important;
      pointer-events: none !important;

      &:before {
        color: $color-silver-chalice !important;
      }
    }

    &-wrapper {
      display: flex;
      align-items: center;
    }

    &-slide {
      opacity: 0 !important;
      pointer-events: none !important;
      position: relative;
      top: 20px;
      max-height: 420px;
      min-height: 420px;

      &-active {
        text-align: center;
        opacity: 1 !important;
        pointer-events: all !important;
      }

      &-prev {
        opacity: 0 !important;
      }

      &-active, &-prev, &-next, &-before-prev {
        &:after {
          display: none !important;
        }
      }
    }
  }
}
</style>
